import { render, staticRenderFns } from "./SchoolVFairInfo.vue?vue&type=template&id=8b7c3a44&"
import script from "./SchoolVFairInfo.vue?vue&type=script&lang=js&"
export * from "./SchoolVFairInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports